import Vue from 'vue';
import Select2MultipleControl from 'v-select2-multiple-component';
Vue.component('Select2MultipleControl', Select2MultipleControl);

!(function($) {
  "use strict";

  new Vue({
    el: '#contact_form_app',
    data: {
      type_options: {},
      contact: {
        message_type: "",
        email: "",
        name: "",
        phone: "",
        service_units: "",
        subject: "",
        message: "",
      }
    },
    mounted: function() {
      let that = this;

      $.ajax({
        url: '/contacts/get_form_data',
        type: 'GET',
        dataType: 'json',
      }).done(function(data) {
        that.type_options = data.type_options;
      });

    },
    methods: {
      submit: function() {
        var token = document.querySelector('meta[name="csrf-token"]').content;

        if (this.contact.message_type == "" || this.contact.email == "" || 
          this.contact.name == "" || this.contact.subject == "" || 
          this.contact.phone == "" || this.contact.service_units == "" || this.contact.message == "") {
          $(".err-message").removeClass('hidden');
          return;
        }

        $.ajax({
          url: '/contacts',
          type: 'POST',
          dataType: 'json',
          data: {authenticity_token: token,contact: this.contact},
        }).done(function(data) {
          $("#contact_form").addClass('hidden');
          $("#contact_sucesss_message").removeClass('hidden');
          // window.location = "/"
        });
      },
    },
  });

})(jQuery);
